<template>
    <div>
        <div class="p-col-12 p-md-10 p-mx-auto box p-p-4">
            <div class="p-text-right">
                <Button
                    v-show="isNotificationCategoriesVisible"
                    :label="notificationCategoriesReorderable ? 'Complete Reorder' : 'Reorder Categories'"
                    @click="notificationCategoriesReorderable = !notificationCategoriesReorderable"
                    class="p-button-sm p-button-text p-button-outlined p-button-info p-text-right p-mr-4" /> 

                <Button
                    label="Notification Categories"
                    @click="toggleNotificationCategoryForm()"
                    class="p-button-sm p-button-text p-button-outlined p-button-info p-text-right" />
            </div>

            <!-- notification categories -->
            <div v-show="isNotificationCategoriesVisible" 
                class="card p-formgrid p-grid p-jc-center p-pt-4">
                <div class="p-col-3" style="">
                    <div class="card p-flex-column p-grid p-text-left p-mr-2">
                        <div class="p-col">
                            <span class="p-float-label p-mb-2 p-inputtext-lg">
                                <InputText id="name" type="text" v-model="notificationCategoryForm.name" />
                                <label for="name">Name</label>
                            </span>
                        </div>
                        <div class="p-col">
                            <span class="p-float-label p-mb-1 p-inputtext-lg">
                                <InputText id="topic" type="text" v-model="notificationCategoryForm.topic" />
                                <label for="topic">Topic</label>
                            </span>
                        </div>
                        <div class="p-col">
                            <Button icon="pi pi-check"
                                label="Add category"
                                @click="addNotificationCategory()"
                                class="p-button-text p-button-info" />
                        </div>
                    </div>
                </div>
                <div class="p-col-9" style="">
                    <DataTable :value="notificationCategories" editMode="row" dataKey="id"
                        v-model:editingRows="editingRows"
                        @row-edit-save="onRowEditSave"
                        @rowReorder="onRowReorder" responsiveLayout="scroll" >
                        <Column :rowReorder="notificationCategoriesReorderable" headerStyle="width: 3rem" :reorderableColumn="false" />
                        <Column field="topic" header="Topic" style="width:33%">
                            <template #editor="{data, field}">
                                <InputText v-model="data[field]" />
                            </template>
                        </Column>
                        <Column field="name" header="Name" style="width:32%">
                            <template #editor="{data, field}">
                                <InputText v-model="data[field]" />
                            </template>
                        </Column>
                        <Column field="is_team" header="is Team" style="width:10%" bodyStyle="text-align:center">
                            <template #editor="{data, field}">
                                <InputSwitch v-model="data[field]" />
                            </template>
                        </Column>
                        <Column :rowEditor="true" style="width:20%" bodyStyle="text-align:right; "></Column>
                        <Column header="" style="width:5%" bodyStyle="text-align:left; ">
                            <template #body="item">
                                <div style="">
                                    <Button label="" icon="pi pi-trash" class="p-button-rounded p-button-text p-button-plain"
                                        @click="deleteNotificationCategory(item.data.id)" />
                                </div>
                            </template>
                            <template #editor="{}">
                            </template>
                        </Column>
                    </DataTable>
                </div>
            </div>

            <!-- notifications -->
            <div class="p-grid p-mx-auto">
                <div class="p-col-12 p-md-9 p-mx-auto">
                    <Paginator 
                        :rows="itemPerPage"
                        :totalRecords="itemTotalCount"
                        @page="onPage($event)" />

                    <ProgressBar mode="indeterminate" v-show="isItemListLoading" style="height: .2em" />

                    <div v-show="!isItemListLoading">
                        <div v-for="(notification, index) in notificationList"
                            :key="notification.id"
                            :class="{'zero' : index % 2 == 0, 'one' : index % 2 == 1}"
                            class="p-grid p-jc-center p-mt-2">
                            <div class="p-col-2 p-text-center p-ai-center vertical-container">
                                <p class="category-name">{{notification.date}}</p> <br />
                                <i :class="notification.iconClass"></i><br />
                                {{notification.type}}<br/>
                                <b><small>#{{notification.id}}</small></b>
                                <p align="left" v-show="notification.fcm_token_count !== undefined && notification.fcm_token_count !== null">
                                    <small>
                                        Success / Failure / Total <br/>
                                        {{notification.success_count}} / {{notification.failure_count}} / {{notification.fcm_token_count}}
                                    </small>
                                </p>
                            </div>
                            <div class="p-col-2 p-ai-center vertical-container" v-show="notification.type === 'news'">
                                <img :src="notification.img_url"
                                    style="max-width:80%;" />
                                <div class="p-text-left">
                                    <p v-for="categoryId in notification.category_ids" class="category-name" :key="categoryId">{{getNotificationCategoryName(categoryId)}}</p>
                                </div>
                            </div>
                            <div class="p-text-left"
                                :class="{'p-col-6' : notification.type === 'news', 'p-col-8' : notification.type !== 'news'}">
                                <h3>{{notification.title}}</h3>
                                <p v-show="notification.subtitle !== undefined && notification.subtitle !== null && notification.subtitle.length > 0">
                                    {{notification.subtitle}}
                                </p>
                            </div>
                            <div class="p-col-2 p-grid p-ai-center vertical-container">
                                <div v-show="notification.type === 'news'
                                    && (notification.is_sent === undefined || notification.is_sent === false)
                                    && (notification.message_id === undefined || notification.message_id === null || notification.message_id === '')
                                    && (notification.fcm_token_count === undefined || notification.fcm_token_count === null || notification.fcm_token_count === 0)">
                                    <Button icon="pi pi-pencil" @click="showUpdateDialog(notification, index)" class="p-button-rounded p-button-text p-mr-2 p-button-plain" />
                                    <Button icon="pi pi-trash" @click="deleteNotification(notification.id)" class="p-button-rounded p-button-text p-button-plain" />
                                </div> <br />
                                <div class="p-text-center">
                                    <Button label="Send (Topic)" icon="pi pi-send" @click="sendNotification(notification, index)" class="p-button-rounded p-button-text"
                                        v-show="notification.type === 'news'
                                        && (notification.is_sent === undefined || notification.is_sent === false)
                                        && (notification.message_id === undefined || notification.message_id === null || notification.message_id === '')
                                        && (notification.fcm_token_count === undefined || notification.fcm_token_count === null || notification.fcm_token_count === 0)"
                                        :class="notification.sending ? 'p-button-plain' : 'p-button-success'"
                                        :disabled="notification.sending" />
                                    <br/>
                                    <br/>
                                    <Button label="Send All (RabbitMQ)" icon="pi pi-send" @click="sendNotificationRabbitMQ(notification, index)" class="p-button-rounded p-button-text"
                                        v-show="notification.type === 'news' && (notification.category_ids.includes(492))
                                        && (notification.is_sent === undefined || notification.is_sent === false)
                                        && (notification.message_id === undefined || notification.message_id === null || notification.message_id === '')
                                        && (notification.fcm_token_count === undefined || notification.fcm_token_count === null || notification.fcm_token_count === 0)"
                                        :class="notification.sending ? 'p-button-plain' : 'p-button-warning'"
                                        :disabled="notification.sending" />
                                    <ProgressSpinner style="width:25px; height:25px" class="p-ml-2"
                                        strokeWidth="4" fill="var(--surface-ground)" animationDuration="1.5s"
                                        v-show="notification.sending" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <ProgressBar mode="indeterminate" v-show="isItemListLoading" style="height: .2em" />

                    <Paginator 
                        :rows="itemPerPage"
                        :totalRecords="itemTotalCount"
                        @page="onPage($event)" />
                </div>
            </div>
        </div>
        
        <!-- update notification modal dialog -->
        <Dialog v-model:visible="showDialog" header="Update Notification" modal maximizable 
            class="p-col-12 p-md-8 p-mx-auto">
            <div class="p-grid p-jc-center">
                <div class="">
                    <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-12 p-text-center">
                            <Image imageClass="gallery-picture" preview
                                style="width:100% !important;"
                                :src="dialogNotification.img_url ?? pictureDefaultPlaceholder" />
                        </div>

                        <div class="p-field p-col-12">
                            <label for="img_url">Image Url</label>
                            <InputText id="img_url" v-model.trim="dialogNotification.img_url" />
                        </div>

                        <div class="p-field p-col-12">
                            <label for="notification_categories">Notification Categories</label>
                            <MultiSelect id="notification_categories" v-model="dialogSelectedNotificationCategories" :options="notificationCategories" :filter="true"
                                display="comma"
                                optionLabel="name" placeholder="Select Categories" />
                        </div>

                        <div class="p-field p-col-12">
                            <label for="title">Title</label>
                            <InputText id="title" v-model="dialogNotification.title" required="true" />
                        </div>

                        <div class="p-field p-col-12">
                            <label for="subtitle">Subtitle</label>
                            <Textarea id="subtitle" v-model="dialogNotification.subtitle" :autoResize="true" />
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <div class="p-grid">
                    <div class="p-col-3 p-md-6 p-text-left">
                        <Button label="Cancel" @click="dismissNotificationUpdateDialog()" class="p-button-text p-button-secondary" />
                    </div>
                    <div class="p-col-9 p-md-6 p-text-right">
                        <Button icon="pi pi-save" @click="updateNotification(dialogNotification.index)" class="p-button-raised" label="Save" />
                    </div>
                </div>
            </template>
        </Dialog>
    </div>

    <Divider align="center" class="p-mt-6">
        <div class="p-d-inline-flex p-ai-center">
        <b>About</b>
        </div>
    </Divider>

    <div class="p-col-12 p-md-9 p-mx-auto p-mt-2 p-text-left">
        <div class="p-d-flex">
        <i class="fa fa-info p-mr-3"></i> Uygulamalara gönderilecek içerik bildirimleri ve bildirim kategorileri buradan yönetilir.
        <br/> Bildirim kategorileri için ekleme, düzeltme, silme işlemleri yapılabilir. Ayrıca kategorilerin gösterim sırası da değiştirilebilir.
        <br/> Haber içerikleri için oluşturulan bildirimler listelenir.
        <br/> Herhangi bir platforma bildirim gönderilmemiş bildirimler için düzenleme ve silme butonları aktiftir. 
        <br/> Platformlardan yalnızca birine gönderilen bildirimler için yalnızca Gönder butonu görünür ve yalnızca gönderim sağlanmamış platforma bildirim gönderir.
        <br/> Android ve iOS platformlarından her ikisine de gönderilen bildirimler için işlem butonları görünmez. (tekrar gönderilemez, düzenlenemez, silinemez)
        </div>
    </div>
</template>

<style>
.one {
    background:#2d3744;
    border-radius: .2rem;
}

.zero {
    background: #313d4d;
    border-radius: .2rem;
}

.category-name {
    font-size: 0.8rem;
    margin: 0.1rem;
}

.gallery-picture {
    max-width: 175px;
    max-height: 150px;
    object-fit: contain;
    text-align: center;

    border-radius: 4px;
    /* display: inline; */
}
</style>

<style lang="scss" scoped>
::v-deep(.editable-cells-table td.p-cell-editing) {
    padding-top: 0;
    padding-bottom: 0;
}
</style>

<script>
import axios from "axios";
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Textarea from 'primevue/textarea'
import InputSwitch from 'primevue/inputswitch'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import ProgressBar from 'primevue/progressbar'
import Paginator from 'primevue/paginator';
import Dialog from 'primevue/dialog';
import MultiSelect from 'primevue/multiselect';
import ProgressSpinner from 'primevue/progressspinner';
import Divider from 'primevue/divider';
import Image from 'primevue/image';

import moment from 'moment';
import Const from '../utils/const'
import { isEmpty } from '../utils/utils'

let SpringApi;

export default {
    name: 'NotificationManagement',
    emits: ["loginResult", "pageLoaded"],
    components: {
        Button, InputText, Image, Textarea, DataTable, Column, InputSwitch, ProgressBar, Paginator, Dialog, MultiSelect, ProgressSpinner, Divider
    },
    data() {
        return {
            notificationCategories: [],
            isNotificationCategoriesVisible: false,
            notificationCategoryForm: {},
            editingRows: [],
            notificationCategoriesReorderable: false,
            itemPerPage: 0, 
            itemTotalCount: 0,
            isItemListLoading: false,
            notificationList: [],
            listCurrentPage: 1,
            showDialog: false,
            dialogNotification: {},
            pictureDefaultPlaceholder: 'images/placeholder.png',
            dialogSelectedNotificationCategories: []
        }
    },
    beforeMount() {
        SpringApi = axios.create({
            baseURL : process.env.VUE_APP_SPRING_API_URL,
            headers: {
                'Authorization': 'Bearer ' + this.$cookies.get('token')
            }
        });

        var page = {
            title: "Notification Management"
        }
        this.$emit('pageLoaded', page)
    },
    mounted() {
        let self = this
        
        self.loadNotificationCategories()
    },
    methods: {
        toggleNotificationCategoryForm() {
            this.isNotificationCategoriesVisible = !this.isNotificationCategoriesVisible

            if(this.notificationCategories === null || this.notificationCategories === undefined || this.notificationCategories.length == 0) {
                this.loadNotificationCategories()
            }
        },
        loadNotificationCategories() {
            let self = this,
                cookies = self.$cookies,
                toast = self.$toast,
                token = cookies.get('token');

            self.$http.get('api/notification-categories', {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            })
            .then(function (response) {
                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set('token', response.headers['refresh-token']);
                    let data = response.data

                    self.notificationCategories = data.items

                    // bildirim kategorilerini gösterebilmek icin kategorilerden sonra cagrildi
                    self.getNotifications()
                } else if(response.data.kod === Const.KOD.oturumSonlandi) {
                    self.$router.push('/login')
                } else {
                    toast.add({severity:'warn', summary: 'Loading notification categories failed', detail:response.data.mesaj, life: 3000});
                }
            })
            .catch(function (err) {
                toast.add({severity:'error', summary: 'Error', detail:err});
                console.log(err)
            });
        },
        addNotificationCategory() {
            let self = this,
                toast = self.$toast,
                notificationCategoryForm = self.notificationCategoryForm,
                toastMessage = null,
                cookies = self.$cookies,
                token = self.$cookies.get('token');

            if(isEmpty(notificationCategoryForm.topic)) {
                toastMessage = 'Topic is empty!'
            } else if(isEmpty(notificationCategoryForm.name)) {
                toastMessage = 'Name is empty!'
            }

            if(!isEmpty(toastMessage)) {
                toast.add({severity:'warn', summary: 'Something missing!', detail: toastMessage, life: 3000});
                return
            }

            self.$http.post('api/notification-categories', notificationCategoryForm, {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            })
            .then(function (response) {
                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set('token', response.headers['refresh-token']);
                    let newAddedItem = response.data.notificationCategory
                    
                    self.notificationCategories.push(newAddedItem)

                    toast.add({severity:'success', summary: 'Success', detail: 'Notification category added successfully.', life: 3000});

                    self.notificationCategoryForm = {}
                } else {
                    console.log(response)
                    toast.add({severity:'warn', summary: 'Notification category insert failed', detail:response.data.mesaj, life: 3000});
                }
            })
            .catch(function (err) {
                console.log(err)
                toast.add({severity: 'error', summary: 'Error', detail: err});
            });

        },
        deleteNotificationCategory(notificationCategoryId) {
            let self = this,
                toast = self.$toast,
                cookies = self.$cookies,
                token = self.$cookies.get('token');
            
            this.$confirm.require({
                message: 'Are you sure you want to delete this notification category?',
                header: 'Delete',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Delete',
                rejectLabel: 'Cancel',
                accept: () => {
                    self.$http.delete('api/notification-categories/'+notificationCategoryId, {
                        headers: {
                            'authorization': 'Bearer ' + token
                        }
                    })
                    .then(function (response) {
                        if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                            cookies.set("token", response.headers['refresh-token']);

                            self.loadNotificationCategories()

                            toast.add({severity:'success', summary: 'Success', detail: 'Notification category deleted successfully.', life: 3000});
                        } else {
                            console.log(response)
                            toast.add({severity:'warn', summary: 'Deleting Notification category failed', detail:response.data.mesaj, life: 3000});
                        }
                    })
                    .catch(function (err) {
                        console.log(err)
                        toast.add({severity: 'error', summary: 'Error', detail: err});
                    });
                },
                reject: () => {
                }
            });
        },
        onRowEditSave(event) {
            let { newData, index } = event;

            let self = this,
                notificationCategoryId = newData.id,
                newNotificationCategory = {
                    id: newData.id,
                    topic: newData.topic,
                    name: newData.name,
                    is_team: newData.is_team
                },
                toast = self.$toast,
                toastMessage = null,
                cookies = self.$cookies,
                token = cookies.get('token');
            
            if(isEmpty(newNotificationCategory.topic)) {
                toastMessage = 'Topic is empty!'
            } else if(isEmpty(newNotificationCategory.name)) {
                toastMessage = 'Name is empty!'
            }

            if(!isEmpty(toastMessage)) {
                toast.add({severity:'warn', summary: 'Something missing!', detail: toastMessage, life: 3000});
                return
            }

            self.$http.put('api/notification-categories/'+notificationCategoryId, newNotificationCategory, {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            })
            .then(function (response) {
                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set('token', response.headers['refresh-token']);
                    // let news = response.data.news
                    
                    self.notificationCategories[index] = response.data.notificationCategory;

                    toast.add({severity:'success', summary: 'Success', detail: 'Updated successfully.', life: 3000});
                } else {
                    toast.add({severity:'warn', summary: 'Update failed', detail:response.data.mesaj, life: 3000});
                }
            })
            .catch(function (err) {
                console.log(err)
                toast.add({severity: 'error', summary: 'Error', detail: err});
            });

        },
        onRowReorder(event) {
            let self = this,
                oldItems = self.notificationCategories,
                newItems = event.value,
                toast = self.$toast,
                cookies = self.$cookies,
                token = cookies.get('token'),
                reorderedItems = [];

            for (let i = 0; i < newItems.length; i++) {
                let mOldItem = oldItems[i],
                    mNewItem = newItems[i]

                if(mNewItem.id != mOldItem.id) {
                    reorderedItems.push({id: mNewItem.id, order: i})
                }
            }

            if(reorderedItems.length == 0) {
                toast.add({ severity:'warning', summary: 'Notification categories order not changed!', life: 3000});
                return
            }

            self.$http.post('api/notification-categories/reorder', reorderedItems, {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            })
            .then(function (response) {
                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set('token', response.headers['refresh-token']);
                    
                    toast.add({severity:'success', summary: 'Success', detail: 'Re-order done successfully.', life: 1500});

                    self.loadNotificationCategories()
                } else {
                    console.log(response)
                    toast.add({severity:'warn', summary: 'Re-order failed', detail:response.data.mesaj, life: 3000});
                }
            })
            .catch(function (err) {
                console.log(err)
                toast.add({severity: 'error', summary: 'Error', detail: err});
            });
        },
        getNotifications() {
            let self = this,
                toast = self.$toast,
                cookies = self.$cookies,
                token = self.$cookies.get('token');
            
            self.isItemListLoading = true
            self.$http.get('api/notifications?page='+self.listCurrentPage, {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            })
            .then(function (response) {
                self.isItemListLoading = false
                let data = response.data
                if(!isEmpty(data.kod) && data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set("token", response.headers['refresh-token']);
                    self.itemPerPage = data.itemPerPage
                    self.itemTotalCount = data.totalCount

                    data.items.forEach(item => {
                        let date = new Date(item.log_date)
                        item.date = moment(date).format('DD/MM/YYYY HH:mm');

                        var iconClass = 'pi-fw fa fa-newspaper'
                        if(item.type === 'private_message') {
                            iconClass = 'pi pi-envelope'
                        }
                        item.iconClass = iconClass
                        
                        // let teams = ""
                        // let mSelectedTeams = []
                        // if (!isEmpty(item.team1)) {
                        //     teams += item.team1;
                        //     mSelectedTeams.push({ss_team_id: item.ss_team_id, name: item.team1})
                        
                        //     if (!isEmpty(item.team2)) {
                        //         teams += ', ';
                        //     }
                        // }
                        // if (!isEmpty(item.team2)) {
                        //     teams += item.team2;
                        //     mSelectedTeams.push({ss_team_id: item.ss_team_id_2, name: item.team2})
                        // }
                        // item.newsId = item.id
                        // item.selectedTeams = mSelectedTeams
                        // item.teams = teams
                    })

                    self.notificationList = data.items
                } else if(data.kod === Const.KOD.oturumSonlandi) {
                    self.$router.push('/login')
                } else {
                    toast.add({severity:'warn', summary: 'Loading news failed', detail:response.data.mesaj, life: 3000});
                }
            })
            .catch(function (err) {
                self.isItemListLoading = false
                console.log(err)
                toast.add({severity:'error', summary: 'Error', detail:err});
            });
        },
        onPage(event) {
            let self = this,
                newPage = event.page + 1

            this.$router.push('/notification-management?page='+newPage)

            self.listCurrentPage = newPage
            self.getNotifications()
        },
        showUpdateDialog(notification, index) {
            let self = this
            
            self.showDialog = !self.showDialog

            if(self.showDialog) {
                self.dialogNotification = {
                    id: notification.id,
                    img_url: notification.img_url,
                    title: notification.title,
                    subtitle: notification.subtitle,
                    category_ids: notification.category_ids,
                    index: index
                }

                self.dialogSelectedNotificationCategories = []
                self.notificationCategories.forEach(category => {
                    if(notification.category_ids.includes(category.id)) {
                        self.dialogSelectedNotificationCategories.push(category)
                    }
                })
            }
        },
        updateNotification(index) {
            let self = this,
                cookies = self.$cookies,
                toast = self.$toast,
                toastMessage = null,
                token = self.$cookies.get('token');
            let mImgUrl = self.dialogNotification.img_url
            let mTitle = self.dialogNotification.title
            let mSubtitle = self.dialogNotification.subtitle
            let mSelectedCategories = self.dialogSelectedNotificationCategories
            let mNotificationId = self.dialogNotification.id

            if(isEmpty(mTitle)) {
                toastMessage = 'Title is empty!'
            } else if(isEmpty(mSelectedCategories)) {
                toastMessage = 'Notification categories empty!'
            }

            if(!isEmpty(toastMessage)) {
                toast.add({severity:'warn', summary: 'Something missing!', detail: toastMessage, life: 3000});
                return
            }

            var categoryIds = []
            mSelectedCategories.forEach(item => {
                categoryIds.push(item.id)
            })

            let notificationForm = {
                img_url: mImgUrl,
                title: mTitle,
                subtitle: mSubtitle,
                category_ids: categoryIds
            }

            self.$http.put('api/notifications/'+mNotificationId, notificationForm, {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            })
            .then(function (response) {
                if(!isEmpty(response.data.kod) && response.data.kod == Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set("token", response.headers['refresh-token']);

                    self.dismissNotificationUpdateDialog()

                    let mNotification = response.data.notification
                    let date = new Date(mNotification.log_date)
                    mNotification.date = moment(date).format('DD/MM/YYYY HH:mm');

                    var iconClass = 'pi-fw fa fa-newspaper'
                    if(mNotification.type === 'private_message') {
                        iconClass = 'pi pi-envelope'
                    }
                    mNotification.iconClass = iconClass
                    self.notificationList[index] = mNotification

                    toast.add({severity:'success', summary: 'Success', detail: 'Notification updated successfully.', life: 3000});
                } else {
                    toast.add({severity:'warn', summary: 'Update notification failed', detail:response.data.mesaj, life: 3000});
                }
            })
            .catch(function (err) {
                console.log(err)
                toast.add({severity: 'error', summary: 'Error', detail: err});
            });
        },
        dismissNotificationUpdateDialog() {
            let self = this
            
            self.showDialog = false
            self.dialogNotification = {}
            self.dialogSelectedNotificationCategories = []
        },
        getNotificationCategoryName(notificationCategoryId) {
            let notificationCategories = this.notificationCategories

            if(notificationCategories === undefined || notificationCategories === null || notificationCategories.length == 0) {
                return '';
            }

            let item = notificationCategories.filter(a => {
                return a.id == notificationCategoryId
            })

            return item !== undefined && item !== null && item.length == 1 ? item[0].name : ''
        },
        deleteNotification(notificationId) {
            let self = this,
                toast = self.$toast,
                cookies = self.$cookies,
                token = self.$cookies.get('token');
            
            this.$confirm.require({
                message: 'Are you sure you want to delete this notification?',
                header: 'Delete',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Delete',
                rejectLabel: 'Cancel',
                accept: () => {
                    self.$http.delete('api/notifications/'+notificationId, {
                        headers: {
                            'authorization': 'Bearer ' + token
                        }
                    })
                    .then(function (response) {
                        if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                            cookies.set("token", response.headers['refresh-token']);

                            self.getNotifications()
                            self.dismissNotificationUpdateDialog()

                            toast.add({severity:'success', summary: 'Success', detail: 'Notification deleted successfully.', life: 3000});
                        } else {
                            toast.add({severity:'warn', summary: 'Deleting notification failed', detail:response.data.mesaj, life: 3000});
                        }
                    })
                    .catch(function (err) {
                        console.log(err)
                        toast.add({severity: 'error', summary: 'Error', detail: err});
                    });
                },
                reject: () => {
                }
            });
        },
        sendNotification(notification, index) {
            let self = this,
                toast = self.$toast,
                cookies = self.$cookies,
                token = self.$cookies.get('token'),
                notificationId = notification.id

            notification.sending = true
            self.$http.post('api/notifications/'+notificationId+'/send', null, {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            })
            .then(function (response) {
                notification.sending = false
                if(!isEmpty(response.data.kod) && response.data.kod == Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set("token", response.headers['refresh-token']);

                    let mNotification = response.data.notification
                    let date = new Date(mNotification.log_date)
                    mNotification.date = moment(date).format('DD/MM/YYYY HH:mm');

                    var iconClass = 'pi-fw fa fa-newspaper'
                    if(mNotification.type === 'private_message') {
                        iconClass = 'pi pi-envelope'
                    }
                    mNotification.iconClass = iconClass
                    self.notificationList[index] = mNotification

                    toast.add({severity:'success', summary: 'Success', detail: response.data.mesaj, life: 3000});
                } else {
                    toast.add({severity:'warn', summary: 'Sending notification failed', detail:response.data.mesaj, life: 3000});
                }
            })
            .catch(function (err) {
                notification.sending = false
                console.log(err)
                toast.add({severity: 'error', summary: 'Error', detail: err});
            });
        },
        async sendNotificationRabbitMQ(notification, index) {
            let self = this,
                toast = self.$toast,
                notificationId = notification.id

            notification.sending = true

            try {
                let response = await SpringApi.post('notifications/'+notificationId+'/send-rabbitmq')
            
                if(!isEmpty(response.data.kod) && response.data.kod == Const.KOD.basarili) {
                    let mNotification = notification
                    mNotification.is_sent = true
    
                    var iconClass = 'pi-fw fa fa-newspaper'
                    if(mNotification.type === 'private_message') {
                        iconClass = 'pi pi-envelope'
                    }
                    mNotification.iconClass = iconClass
                    self.notificationList[index] = mNotification
    
                    toast.add({severity:'success', summary: 'Success', detail: response.data.mesaj, life: 3000});
                } else {
                    toast.add({severity:'warn', summary: 'Sending notification failed', detail: response.data.mesaj, life: 3000});
                }
            } catch(error) {
                console.log(error)
                toast.add({severity:'warn', summary: 'Sending notification failed', detail:error, life: 3000});
            } finally {
                notification.sending = false
            }
        }
    }
}
</script>
